import { render, staticRenderFns } from "./PeriodsMemberOtoCommunication.vue?vue&type=template&id=6495d768&scoped=true"
import script from "./PeriodsMemberOtoCommunication.vue?vue&type=script&lang=js"
export * from "./PeriodsMemberOtoCommunication.vue?vue&type=script&lang=js"
import style0 from "./PeriodsMemberOtoCommunication.vue?vue&type=style&index=0&id=6495d768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495d768",
  null
  
)

export default component.exports